"use strict";

export function initInScope($scope) {
    $scope.find('.js-remove-map-xs-overlay').on('click', function (evt) {
        evt.preventDefault();
        $(this).closest('div').remove();
    });
}